import type { Webhook } from 'src/types/webhook'

import api from 'src/constants/api'

import useAccount from 'src/hooks/utils/useAccount'
import useQuery from 'src/hooks/utils/useQuery'

const useWebhooksQuery = () => {
  const account = useAccount()
  return useQuery(
    ['getWebhooks', account.id],
    async ({ signal }) => {
      const response = await api.get(`/webhooks/account/${account.id}/webhooks`, { signal })
      return response.data as Webhook[]
    },
    {
      errorMessage: 'Failed to fetch webhooks',
      cacheTime: 60 * 1000 * 5,
      refetchOnWindowFocus: false,
      enabled: !!account.id
    }
  )
}

export default useWebhooksQuery
